//#region src/utils/schema-aml-parser/types.ts
var EMPTY_NAMESPACE = {
	database: "",
	catalog: "",
	schema: ""
};
//#endregion
export { EMPTY_NAMESPACE };
